// extracted by css-extract-rspack-plugin
export default {"filter_select":"Dde6EDHdZMmABOAO","select_filter":"JnGrxmAKYkomOHKI"};